<template>
  <div v-if="!(editable || shouldEdit)" class="d-flex flex-wrap mb-3">
    <h6 class="font-size-md text-mcf-color w-100"><span v-if="required" class="text-danger ml-n1">*</span>{{ $t('personal-info.address') }}</h6>
    <div class=" font-size-base text-mcf-color">{{ currentAddress }}</div>
  </div>
  <!-- 開始畫面上純顯示的地址框 Begin-->
  <b-form-group v-else-if="!updateAddress"
    class="font-size-md">
    <h6 class="font-size-md text-mcf-color"><span v-if="required" class="text-danger ml-n1">*</span>{{ $t('personal-info.address') }}</h6>
    <b-form-textarea
      class="w-100 bg-white"
      @click="setMemberSourceData({ id: 'updateAddress', value: true })"
      :value="currentAddress"
      :rows="row"
      :max-rows="row"
      v-if="haveValue"
    ></b-form-textarea>
    <b-form-input
      @click="setMemberSourceData({ id: 'updateAddress', value: true })"
      v-else
      class="bg-white"
      :placeholder="$t('personal-info.address')"
      type="text"
    ></b-form-input>
  </b-form-group>
  <!-- 開始畫面上純顯示的地址框 End-->
  <!-- 點擊地址框後顯示的地址編輯 Begin-->
  <b-form-group v-else>
    <slot name="title">
     <h6 class="font-size-md text-mcf-color"><span v-if="required" class="text-danger ml-n1">*</span>{{ $t('personal-info.address') }}</h6>
    </slot>
    <!-- 國家的下拉選單 Begin-->
    <slot name="country">
    <b-form-select v-model="country" class="bg-white">
      <option :value="null" :disabled="required">{{ $t('personal-info.country') }}</option>
      <option
        :value="country.country"
        v-for="country in countrys"
        :key="country.iso_3166_1"
      >{{ country.country }}</option>
    </b-form-select>
    <b-form-invalid-feedback :state="validateCountryState">{{ $t('global.please-choose') }}</b-form-invalid-feedback>
    </slot>
    <!-- 國家的下拉選單 End-->
    <!-- 省份的下拉選單 Begin-->
    <b-form-select
      @change="validateProvince"
      v-model="currentProvince"
      class="bg-white mt-3"
      v-if="country==='CN'">
      <option :value="null" disabled>{{ $t('personal-info.cn-province') }}</option>
      <option
        :value="cnProvince.fullname"
        v-for="cnProvince in cnProvinceList"
        :key="cnProvince.id"
      >{{cnProvince.fullname}}</option>
    </b-form-select>
    <b-form-invalid-feedback
      v-if="country!=='TW'"
      :state="validateProvinceState"
    >{{validateProvinceMessage}}</b-form-invalid-feedback>
    <!-- 省份的下拉選單 End-->
    <!-- 城市的下拉選單或輸入框 Begin-->
    <b-form-select
      @change="changeCity"
      v-model="currentCity"
      class="bg-white mt-3"
      v-if="country==='TW'"
    >
      <option :value="null" disabled>{{ $t('personal-info.city') }}</option>
      <option :value="city.city" v-for="city in citys" :key="city.city">{{ city.city }}</option>
    </b-form-select>
    <b-form-select
      @change="changeCity"
      v-model="currentCity"
      class="bg-white mt-3"
      v-else-if="country==='CN'"
    >
      <option :value="null" disabled>{{ $t('personal-info.city') }}</option>
      <option :value="city.fullname" v-for="city in citys" :key="city.id">{{ city.fullname }}</option>
    </b-form-select>
    <b-form-invalid-feedback :state="validateCityState">{{ validateCityMessage }}</b-form-invalid-feedback>
    <!-- 城市的下拉選單或輸入框 End-->
    <!-- 區的下拉選單或輸入框 Begin-->
    <b-form-select
      @change="changeDistrict"
      v-model="currentDistrict"
      class="bg-white mt-3"
      v-if="country==='TW'"
    >
      <option :value="null" disabled>{{ $t('personal-info.district') }}</option>
      <option
        :value="district.region"
        v-for="district in districts"
        :key="district.region"
      >{{district.region}}</option>
    </b-form-select>
    <b-form-select
      @change="changeDistrict"
      v-model="currentDistrict"
      class="bg-white mt-3"
      v-else-if="country==='CN'"
    >
      <option :value="null" disabled>{{ $t('personal-info.district') }}</option>
      <option
        :value="district.fullname"
        v-for="district in districts"
        :key="district.id"
      >{{ district.fullname }}</option>
    </b-form-select>
    <b-form-invalid-feedback :state="validateDistrictState">{{ validateDistrictMessage }}</b-form-invalid-feedback>
    <!-- 區的下拉選單或輸入框 End-->
    <!-- 地址的輸入框 Begin-->
    <slot name="address">
    <b-form-input
      v-model="address"
      @blur="validateAddress"
      class="bg-white mt-3"
      :placeholder="$t('personal-info.address')"
      type="text"
      :state="validateAddressState"
      maxlength="100"
    ></b-form-input>
    <b-form-invalid-feedback :state="validateAddressState">{{ $t('global.please-enter') }}</b-form-invalid-feedback>
    </slot>
    <!-- 地址的輸入框 End-->
    <!-- 省份的輸入框 Begin-->
    <b-form-input
      @blur="validateProvince"
      v-if="country!=='TW'&&country!=='CN'"
      maxlength="50"
      v-model="currentProvince"
      class="bg-white mt-3"
      :placeholder="$t('personal-info.province')"
      type="text"
      :state="validateProvinceState"
    ></b-form-input>
    <b-form-invalid-feedback
      v-if="country!=='TW'&&country!=='CN'"
      :state="validateProvinceState"
    >{{ validateProvinceMessage }}</b-form-invalid-feedback>
    <!-- 省份的輸入框 End-->
    <!-- 城市的輸入框 Begin-->
    <b-form-input
      v-if="country!=='TW'&&country!=='CN'"
      @blur="validateCity"
      v-model="currentCity"
      class="bg-white mt-3"
      :placeholder="$t('personal-info.city')"
      type="text"
      :state="validateCityState"
      maxlength="50"
    ></b-form-input>
    <b-form-invalid-feedback
      v-if="country!=='TW'&&country!=='CN'"
      :state="validateCityState"
    >{{ validateCityMessage }}</b-form-invalid-feedback>
    <!-- 城市的輸入框 End-->
    <!-- ZipCode 的輸入框 Begin-->
    <b-form-input
      @blur="findAreaByZipCode"
      :maxlength="country==='TW'?'3':'30'"
      v-model="zipCode"
      class="bg-white mt-3"
      :placeholder="$t('personal-info.zip-code')"
      type="tel"
      :state="validateZipCodeState"
    ></b-form-input>
    <b-form-invalid-feedback :state="validateZipCodeState">{{ validateZipCodeMessage }}</b-form-invalid-feedback>
    <!-- ZipCode 的輸入框 End-->
  </b-form-group>
  <!-- 點擊地址框後顯示的地址編輯 End-->
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  created() {
    if (
      !(
        this.answer.zipCode
        || this.answer.country
        || this.answer.province
        || this.answer.city
        || this.answer.district
        || this.answer.address
      )
      && !this.editable
    ) {
      this.shouldEdit = true;
    }
    // 獲取國家列表
    this.getCountrys()
      .then(() => {
        // 獲取省份、城市列表
        switch (this.country) {
          case 'TW':
            this.callTWAreaAAPI();
            break;
          case 'CN':
            this.callCNAreaAAPI().then(() => {
              if (this.currentProvince) {
                this.setCNCitys().then(() => {
                  this.setDistricts();
                });
              }
            });
            break;
          default:
            break;
        }
      });

    this.browserLanguage = navigator.language;
  },
  data() {
    return {
      // 剛進畫面時有維護地址，顯示之 textarea 的高度
      row: 2,
      // 瀏覽器語系
      browserLanguage: '',
      shouldEdit: false,
      citys: [],
      districts: [],
      validateCountryState: undefined,
      validateProvinceState: undefined,
      validateCityState: undefined,
      validateDistrictState: undefined,
      validateAddressState: undefined,
      validateZipCodeState: undefined,
      validateProvinceMessage: undefined,
      validateCityMessage: undefined,
      validateDistrictMessage: undefined,
      validateZipCodeMessage: undefined,
    };
  },
  computed: {
    ...mapState('memberSource', [
      'countrys',
      'updateAddress',
      'twCityList',
      'cnProvinceList',
    ]),
    // 是否為繁體中文
    isTraditionalChinese() {
      return this.browserLanguage.toLowerCase() === 'zh-tw';
    },
    // 確認是否已有維護之地址
    haveValue() {
      if (
        this.answer.country
        || this.answer.province
        || this.answer.city
        || this.answer.district
        || this.answer.address
        || (this.answer.zipCode !== undefined && this.answer.zipCode.toString())
      ) {
        return true;
      }
      return false;
    },
    // 剛進畫面時顯示的地址
    currentAddress() {
      let address = '';
      let showCountryName = '';
      if (this.isTraditionalChinese) {
        showCountryName = 'name_tw';
      } else {
        showCountryName = 'name_en';
      }
      const country = this.countrys.find(
        (d) => d.country === this.answer.country,
      );
      address = this.addAddress(
        address,
        country ? country[showCountryName] : '',
      );
      address = this.addAddress(address, this.answer.province);
      address = this.addAddress(address, this.answer.city);
      address = this.addAddress(address, this.answer.district);
      address = this.addAddress(address, this.answer.address);
      address = this.addAddress(address, this.answer.zipCode);
      return address;
    },
    // 當前國家
    country: {
      get() {
        if (this.answer.country) {
          return this.answer.country;
        }
        // 若未填地址且瀏覽器語系為繁體，預帶 TW
        if (this.isTraditionalChinese) {
          this.setMemberSourceData({ id: 'updateAddress', value: true });
          this.updateData('country', 'TW');
          return 'TW';
        }
        return null;
      },
      set(value) {
        if (value === null) {
          value = '';
        }
        this.updateData('country', value);
      },
    },
    // 當前省份
    currentProvince: {
      get() {
        if (this.answer.province) {
          return this.answer.province;
        }
        return null;
      },
      set(value) {
        this.updateData('province', value);
      },
    },
    // 當前城市
    currentCity: {
      get() {
        if (this.answer.city) {
          return this.answer.city;
        }
        return null;
      },
      set(value) {
        this.updateData('city', value);
      },
    },
    // 當前區
    currentDistrict: {
      get() {
        if (this.answer.district) {
          return this.answer.district;
        }
        return null;
      },
      set(value) {
        this.updateData('district', value);
      },
    },
    // 當前地址
    address: {
      get() {
        return this.answer.address;
      },
      set(value) {
        this.updateData('address', value);
      },
    },
    // 當前 zipCode
    zipCode: {
      get() {
        return this.answer.zipCode;
      },
      set(value) {
        if (value === null) {
          value = '';
        }
        this.updateData('zipCode', value);
      },
    },
  },
  methods: {
    ...mapActions('memberSource', [
      'getCountrys',
      'getzipcode',
      'getCNZipData',
    ]),
    ...mapMutations('memberSource', ['setMemberSourceData']),
    updateData(target, value) {
      const data = { ...this.answer };
      data[target] = value;
      this.$emit('updateData', { id: this.id, value: data });
    },
    validate() {
      // 驗證所有欄位
      const vCo = this.validateCountry();
      const vP = this.validateProvince();
      const vCi = this.validateCity();
      const vD = this.validateDistrict();
      const vA = this.validateAddress();
      const vZ = this.validateZipCode();
      if (vCo && vP && vCi && vD && vA && vZ) {
        return true;
      }
      this.setMemberSourceData({ id: 'updateAddress', value: true });
      return false;
    },
    validateCountry() {
      // 必填且沒填時
      if (this.required && !this.answer.country && !this.country) {
        this.validateCountryState = false;
        return false;
      }
      this.validateCountryState = true;
      return true;
    },
    validateProvince() {
      // 必填且是CN且沒填時
      if (this.required && this.country === 'CN' && !this.answer.province) {
        this.validateProvinceMessage = this.$t('global.please-choose');
        this.validateProvinceState = false;
        return false;
      }
      this.validateProvinceState = true;
      return true;
    },
    validateCity() {
      // 必填且沒填時
      if (this.required && !this.answer.city) {
        switch (this.country) {
          case 'TW':
          case 'CN':
            break;
          default:
            this.validateCityMessage = '';
            this.validateCityState = true;
            return true;
        }
        this.validateCityMessage = this.$t('global.please-choose');
        this.validateCityState = false;
        return false;
      }
      this.validateCityState = true;
      return true;
    },
    validateDistrict() {
      if (this.required && !this.answer.district) {
        switch (this.country) {
          case 'TW':
          case 'CN':
            break;
          default:
            this.validateDistrictState = true;
            return true;
        }
        this.validateDistrictMessage = this.$t('global.please-choose');
        this.validateDistrictState = false;
        return false;
      }
      this.validateDistrictState = true;
      return true;
    },
    validateAddress() {
      if (this.required && !this.answer.address) {
        this.validateAddressState = false;
        return false;
      }
      this.validateAddressState = true;
      return true;
    },
    validateZipCode() {
      if (
        this.required
        && (this.answer.zipCode === undefined || !this.answer.zipCode.toString())
      ) {
        switch (this.country) {
          case 'TW':
          case 'CN':
            break;
          default:
            this.validateZipCodeMessage = '';
            this.validateZipCodeState = true;
            return true;
        }
        this.validateZipCodeMessage = this.$t('global.please-enter');
        this.validateZipCodeState = false;
        return false;
      }
      const zipCodeRe = /^[0-9]+$/;
      if (this.answer.zipCode.toString()) {
        if (!zipCodeRe.test(this.answer.zipCode)) {
          this.validateZipCodeMessage = this.$t('personal-info.zip-code-error');
          this.validateZipCodeState = false;
          return false;
        }
      }
      this.validateZipCodeMessage = '';
      this.validateZipCodeState = true;
      return true;
    },
    // 組合要顯示的地址
    addAddress(currentAddress, address) {
      if (address !== null && address.toString()) {
        if (!currentAddress) {
          currentAddress += `${address}`;
          this.row = 2;
        } else {
          currentAddress += `\r\n${address}`;
          this.row += 1;
        }
      }
      return currentAddress;
    },
    // 獲取省份、城市列表
    callAreaAAPI() {
      switch (this.country) {
        case 'TW':
          this.callTWAreaAAPI();
          break;
        case 'CN':
          if (!this.cnProvinceList.length) {
            this.callCNAreaAAPI();
          }
          break;
        default:
          break;
      }
    },
    // 呼叫取得 TW 區域 API
    callTWAreaAAPI() {
      if (!this.twCityList.length) {
        this.getzipcode().then(() => {
          this.citys = this.twCityList;
          if (this.currentCity) {
            this.setDistricts();
          }
        });
      } else {
        this.citys = this.twCityList;
        if (this.currentCity) {
          this.setDistricts();
        }
      }
    },
    // 呼叫取得 CN 區域 API
    callCNAreaAAPI() {
      return this.getCNZipData(0).then((res) => {
        this.setMemberSourceData({
          id: 'cnProvinceList',
          value: res.response.data,
        });
      });
    },
    // 獲取城市列表
    setCitys() {
      switch (this.country) {
        case 'TW':
          this.setTWCitys();
          break;
        case 'CN':
          this.setCNCitys();
          break;
        default:
          break;
      }
    },
    // 設定 TW 城市
    setTWCitys() {
      this.callAreaAAPI();
    },
    // 設定 CN 城市
    setCNCitys() {
      return this.getCNZipData(
        this.cnProvinceList.find((d) => d.fullname === this.currentProvince).id,
      ).then((res) => {
        this.citys = res.response.data;
      });
    },
    // 獲取區列表
    setDistricts() {
      if (this.currentCity) {
        switch (this.country) {
          case 'TW':
            this.setTWDistricts();
            break;
          case 'CN':
            this.setCNDistricts();
            break;
          default:
            break;
        }
      }
    },
    setTWDistricts() {
      if (this.currentCity) {
        this.districts = this.citys.find(
          (d) => d.city === this.currentCity,
        ).regions;
      }
    },
    setCNDistricts() {
      return this.getCNZipData(
        this.citys.find((d) => d.fullname === this.currentCity).id,
      ).then((res) => {
        this.districts = res.response.data;
      });
    },
    // 根據 zipCode 設定市及區
    findAreaByZipCode() {
      if (this.country === 'TW') {
        let findZipCode = false;
        for (let index = 0; index < this.citys.length; index += 1) {
          const element = this.citys[index];
          for (let index2 = 0; index2 < element.regions.length; index2 += 1) {
            const element2 = element.regions[index2];
            if (element2.zip === this.zipCode) {
              const data = { ...this.answer };
              data.city = element.city;
              data.district = element2.region;
              data.zipCode = element2.zip;
              this.validateCityState = true;
              this.validateDistrictState = true;
              this.$emit('updateData', { id: this.id, value: data });
              setTimeout(() => {
                this.setTWDistricts();
              }, 1);
              findZipCode = true;
            }
            if (findZipCode) {
              break;
            }
          }
          if (findZipCode) {
            break;
          }
        }
        if (!findZipCode && this.currentCity && this.currentDistrict) {
          const data = { ...this.answer };
          data.zipCode = this.districts.find(
            (d) => d.region === this.currentDistrict,
          ).zip;
          this.$emit('updateData', { id: this.id, value: data });
        }
      }
      if (!(this.country === 'TW' && this.currentDistrict)) {
        this.validateZipCode();
      }
    },
    // 異動城市，且國家為 TW、CN 則清空 區
    changeCity() {
      const data = { ...this.answer };
      data.district = '';
      this.$emit('updateData', { id: this.id, value: data });
      this.setDistricts();
      this.validateCity();
    },
    changeDistrict() {
      this.address = '';
      if (this.country === 'TW') {
        if (this.currentDistrict) {
          const newZipcode = this.districts.find(
            (d) => d.region === this.currentDistrict,
          ).zip;
          if (newZipcode !== this.zipCode) {
            const data = { ...this.answer };
            data.zipCode = this.districts.find(
              (d) => d.region === this.currentDistrict,
            ).zip;
            this.$emit('updateData', { id: this.id, value: data });
          }
        }
      }
      this.validateDistrict();
    },
  },
  props: {
    id: {
      type: String,
    },
    answer: {
      type: Object,
    },
    required: {
      type: Boolean,
    },
    editable: {
      type: Boolean,
    },
  },
  watch: {
    // 異動國家則清空所有欄位
    country() {
      const data = { ...this.answer };
      data.province = '';
      data.city = '';
      data.district = '';
      data.address = '';
      data.zipCode = '';
      if (this.validateProvinceState !== undefined) {
        this.validateProvince();
      }
      if (this.validateCityState !== undefined) {
        this.validateCity();
      }
      if (this.validateDistrictState !== undefined) {
        this.validateDistrict();
      }
      if (this.validateAddressState !== undefined) {
        this.validateAddress();
      }
      if (this.validateZipCodeState !== undefined) {
        this.validateZipCode();
      }
      this.$emit('updateData', { id: this.id, value: data });
      this.callAreaAAPI();
      this.validateCountry();
    },
    // 異動省份，且國家為 CN 則清空 城市及區
    currentProvince() {
      if (this.country === 'CN') {
        const data = { ...this.answer };
        data.city = '';
        data.district = '';
        this.$emit('updateData', { id: this.id, value: data });
        this.districts = [];
        if (this.currentProvince) {
          this.setCitys();
        }
      }
    },
  },
};
</script>
